import { Component, OnInit, ViewChild } from '@angular/core';
import { AuthenticationService } from '../service/authentication.service';
import { ApiService } from '../service/api.service';
import { UtilService } from '../service/util.service';
import { Constants } from '../constants/constants';
import { DatePipe } from '@angular/common';
import { ToastService } from '../service/toast.service';
import { SearchResultsComponent } from '../search-results/search-results.component';
import { SearchDataService } from '../service/search-data.service';
import { BillingPeriodCycle, Period } from '../shared/model/billing-period-cycle.model';

@Component({
  selector: 'app-udr',
  templateUrl: './udr.component.html',
  styleUrls: ['./udr.component.scss']
})
export class UdrComponent implements OnInit {

  usageSelectionOption = [];
  selectedFromDate = new Date();
  selectedToDate = new Date();
  today = new Date();
  selectedSelectionRange: BillingPeriodCycle;

  usageData: Array<any> = new Array<any>();
  accountCategory: string;

  accountType: string;
  account: any = {};
  locationMap: Map<string, any> = new Map();
  chargingPeriodOptions: Array<BillingPeriodCycle> = [];

  //Search result storage variable
  @ViewChild('searchResult') searchResult:SearchResultsComponent;
  searchedUsageList: Array<any>;
  showSearchResult: boolean = false;
  isSearchResult: boolean = false;
  selectedPeriod: number;
  remoteServicesApiReqPayload: { fromDate: Date; toDate: Date; serviceNames: any; };

  constructor(private apiService: ApiService, public authService: AuthenticationService, private datePipe: DatePipe, public utilService: UtilService, private toast: ToastService, private searchService: SearchDataService) { }

  ngOnInit() {
    this.initUsageSelectionOption();
    // this.getAccountLocations();
    this.processSearchResult();
    this.accountCategory = this.apiService.accountDetail.category;
    this.accountType = this.apiService.accountDetail.type;
    this.getBillingCycles();
  }

  ngOnDestroy() {
    this.searchService.resetPreviousSearchResult();
  }

  getBillingCycles() {
    this.utilService.showSpinner();
    this.apiService.getBillingCycles().then((data) => {
      this.utilService.hideSpinner();
      console.log("Billing cycles::", data);
      this.prepareBillingCycle(data);
      if (this.chargingPeriodOptions.length > 0) {
        this.selectedSelectionRange = this.chargingPeriodOptions[0];
        this.onChargingPeriodChange(0);
      }
    }).catch((error) => {
      console.log("err : ", error);
      if (error.status == Constants.HTTP_UNAUTHORISED) {
        this.authService.refreshToken().then(() => {
          this.utilService.hideSpinner();
          console.log("refresh token api executed");
          this.getBillingCycles();
        });
      }
      else {
        this.utilService.hideSpinner();
        if (error && error.error && error.error.message) this.toast.showError(error.error.message);
        else this.toast.showError(Constants.UNKNOWN_ERROR);
      }
    });
  }

  prepareBillingCycle(data: Array<Period>) {
    this.chargingPeriodOptions = [];
    if (data != null && data.length > 0) {
      for (var i = 0; i < data.length; i++) {
        var startDate = data[i].startDate;
        var endDate = data[i].endDate;
        if (i == 0) {
          this.chargingPeriodOptions.push({
            "periodName": "Current Billing Cycle",
            "period": {
              "startDate": startDate,
              "endDate": endDate
            }
          });
          continue;
        }
        this.chargingPeriodOptions.push({
          "periodName": this.datePipe.transform(startDate, this.utilService.countryData.dateFormat, this.utilService.countryData.timezone) + " - " + this.datePipe.transform(endDate, this.utilService.countryData.dateFormat, this.utilService.countryData.timezone),
          "period": {
            "startDate": startDate,
            "endDate": endDate
          }
        });
      };
    }
  }

  onChargingPeriodChange(selectedPeriod) {
    this.selectedPeriod = selectedPeriod;
    console.log("selected selectedPeriod :", selectedPeriod);

    var selectedChargingPeriod = this.chargingPeriodOptions[selectedPeriod];
    this.selectedSelectionRange = selectedChargingPeriod;

    this.selectedFromDate = new Date(selectedChargingPeriod.period.startDate);
    this.selectedToDate = new Date(selectedChargingPeriod.period.endDate);
    this.remoteServicesApiReqPayload = {
      "fromDate": this.selectedFromDate,
      "toDate": this.selectedToDate,
      "serviceNames": null
    }
    this.getUDR();
  }

  initUsageSelectionOption() {
    this.usageSelectionOption = [];
    var toDate = new Date(), y = toDate.getFullYear(), m = toDate.getMonth();
    var fromDate = new Date(y, m, 1);
    this.usageSelectionOption.push(this.datePipe.transform(fromDate, this.utilService.countryData.dateFormat, this.utilService.countryData.timezone) + '-' + this.datePipe.transform(toDate, this.utilService.countryData.dateFormat, this.utilService.countryData.timezone));
    
    toDate.setMonth(toDate.getMonth()-1);
    toDate.setDate(1);
    toDate.setHours(0);
    fromDate = toDate;
    toDate = new Date(new Date().getFullYear(), new Date().getMonth(), 0);
    this.usageSelectionOption.push(this.datePipe.transform(fromDate, this.utilService.countryData.dateFormat, this.utilService.countryData.timezone) + '-' + this.datePipe.transform(toDate, this.utilService.countryData.dateFormat, this.utilService.countryData.timezone));
    this.usageSelectionOption.push("Date Range");
  }

  private processSearchResult() {
    this.searchService.searchedData.subscribe(data => {
      this.searchedUsageList = this.searchService.getSearchedDataForType(Constants.SERVICE_USAGE);
      if (this.searchedUsageList && this.searchedUsageList.length > 0) {
        this.showSearchResult = true;
      }
      else {
        this.showSearchResult = false;
      }
    });
  }

  getUDR() {
    this.utilService.showSpinner();
    var request = {
      "fromDate" : this.selectedFromDate,//"2019-12-11T09:42:57.830Z",
      "toDate" : this.selectedToDate//"2020-12-14T09:42:57.830Z"
    }
    this.searchService.payloadExtra = request;
    this.apiService.getUDR(request).then((data) => {
      this.utilService.hideSpinner();
      console.log("UDR data::", data);
      this.usageData = data;
    }).catch((error) => {
      console.log("err : ", error);
      if (error.status == Constants.HTTP_UNAUTHORISED) {
        this.authService.refreshToken().then(() => {
          this.utilService.hideSpinner();
          console.log("refresh token api executed");
          this.getUDR();
        });
      }
      else {
        this.utilService.hideSpinner();
        if (error && error.error && error.error.message) this.toast.showError(error.error.message);
        else this.toast.showError(Constants.UNKNOWN_ERROR);
      }
    });
  }

  getAccountLocations() {
    this.utilService.showSpinner();
    this.apiService.getFleetLocationList().then((data) => {
      this.utilService.hideSpinner();
      console.log("Account locations data::", data);
      if(data && data.length > 0) {
        this.prepareLocationMap(data);
      }
    }).catch((error) => {
      console.log("err : ", error);
      if (error.status == Constants.HTTP_UNAUTHORISED) {
        this.authService.refreshToken().then(() => {
          this.utilService.hideSpinner();
          console.log("refresh token api executed");
          this.getAccountLocations();
        });
      }
      else {
        this.utilService.hideSpinner();
        if (error && error.error && error.error.message) this.toast.showError(error.error.message);
        else this.toast.showError(Constants.UNKNOWN_ERROR);
      }
    });
  }

  prepareLocationMap(locations: Array<any>) {
    this.locationMap.clear();
    locations.forEach(location => {
      this.locationMap.set(location.id, location);
    });
    console.log("location map::", this.locationMap);
  }

}
